import { render, staticRenderFns } from "./SupervisionQuerylogsTable.vue?vue&type=template&id=976772ea&scoped=true&"
import script from "./SupervisionQuerylogsTable.vue?vue&type=script&lang=js&"
export * from "./SupervisionQuerylogsTable.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionQuerylogsTable.vue?vue&type=style&index=0&id=976772ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976772ea",
  null
  
)

export default component.exports